export enum LocalStorage {
  Tokens = 'tokens',
  User = 'user',
  DeviceId = 'device_id',
}
